<template>
    <div class="boardPage">
        <div id="video_student_list" :class="oneselfPlatform? 'platform' : ''">
            <div
                :class="item.id == 'i'? 'my_video student_video' : 'student_video'"
                v-for="(item, index) in stuRemoteStreamList"
                :key="index"
                :id="item.stream.getId()"
                oncontextmenu="return false;">
                {{ currentVideoPlay(item, index) }}
                <!-- <img v-show="!item.video" :src="stuDefaultBg" class="defaultBg" alt=""> -->
                <span v-if="item.id !== 'i'" class="student_name">{{ item.name }}</span>
                <!-- <div class="student_control" v-show="(item.id == 'i') && student_control_show == item.id">
                    <el-tooltip content="视频开关" placement="top" effect="light">
                        <img
                            :src="item.video? videoIcon[0] : videoIcon[1]"
                            @click="e => handlerStuVideo(item, index)">
                    </el-tooltip>
                    <el-tooltip content="麦克风开关" placement="top" effect="light">
                        <img
                            :src="isAudioPush? audioIcon[0] : audioIcon[1]" 
                            @click="e => handlerStuAudio(!isAudioPush)">
                    </el-tooltip>
                </div> -->
            </div>
            <el-button type="primary"  @click="$refs.settingsDialog.show()">设备</el-button>
           
        </div>
        <div id="paint_box" style="background-color: rgb(240, 240, 240);"></div>
        <SettingDialog :cameraStream="cameraStream" ref="settingsDialog"></SettingDialog>
    </div>
</template>
<script>
import SettingDialog from '@/views/classroom/components/settingsDialog';
export default {
    components: { SettingDialog },
    data() {
        return {
            userId: "",
            userSig: '',
            classId: "",
            boardData: {
                currentBoardId: null, //当前白板ID
                boardIdlist: [], //白板ID列表
                current: 0, //当前白板index
                total: 0 //总页数
            },
            //当前用户状态
            STATUS_UNINIT: 0,
            STATUS_UNLOGIN: 1,
            STATUS_LOGINED: 2,
            STATUS_INCLASS: 3,
            status: 0,
            isPushing: 0, // 是否正在推流
            fileInfoList: [], // 所有文件信息
            currentFileId: null, // 当前文件Id
            stuRemoteStreamList: [],
            cacheStuRemoteStreamList: [],
            teacherRemoteStreamList: [],
            oneselfPlatform: false, //上台
            cameraStream: null,
        }
    },
    created() {
        console.log(this.$route)
        if(this.$route.query) {
            if(this.$route.query.userId) 
                this.userId = this.$route.query.userId
            if(this.$route.query.classId) 
                this.classId = this.$route.query.classId
            if(this.$route.query.userSig) 
                this.userSig = this.$route.query.userSig
        }
        console.log(this.userId)
        console.log(this.userSig)
        console.log(this.classId)
    },
    mounted() {
            this.init();

    },
    methods: {
        // 初始化SDK
        init() {
            if (this.status == this.STATUS_UNINIT) {
                console.log(1)
                this.tic = null;
                this.tic = new TIC({});
                console.log(this.tic);
                this.tic.init(this.institutionConfig.tencentTrtcAppId, res => {
                    if (res.code) {
                        // this.showErrorTip('初始化失败，code:' + res.code + ' msg:' + res.desc);
                    } else {
                        this.status = this.STATUS_UNLOGIN;
                        this.login();
                    }
                });
            } else {
                console.log(2)
                this.login();
            }
        },
        // 登录
        login() {
            this.tic.login({
                userId: this.userId,
                userSig: this.userSig,
            }, (res) => {
                if (res.code) {
                    // this.showErrorTip('登录失败');
                    console.error(res.code);
                } else {
                    console.log('登录成功', res)
                    this.status = this.STATUS_LOGINED;
                    // this.showTip('登录成功');
                    // 增加事件监听
                    this.addTICMessageListener();
                    this.addTICEventListener();
                    this.createClassroom();
                    this.addTICStatusListener()
                    // IM状态监听回调
        
                    this.loginStatus = true;
                }
                this.loading = false;
            });
        },
        // 登出
        logout() {
            new Promise(async resolve => {
                if(this.loginStatus) {
                    this.loginStatus = false;
                    if (this.status == this.STATUS_INCLASS) {
                        console.log("退出登录")
                        this.quitClassroom(async res => {
                           await this.logout_internal();
                           resolve();
                        });
                        return;
                    }
                    await this.logout_internal();
                    resolve();
                }
                resolve();
            })
        },
        /**
         * 增加IM消息监听回调
         */
        addTICMessageListener() {
            this.tic.addTICMessageListener({

                /**
                 * 收到C2C文本消息
                 * @param fromUserId		发送此消息的用户id
                 * @param text				收到消息的内容
                 * @param textLen			收到消息的长度
                 */
                onTICRecvTextMessage: (fromUserId, text, textLen) => {
                    console.log(fromUserId, text, textLen)
                    // if(text.startsWith('##stuLoadPythonCode')) {
                    //     this.currentPythonCode = text.slice(20);
                    //     // this.promptShow = true;
                    // } else if(text.startsWith('##defaultSettings')) {
                    //     console.log(text.split('##defaultSettings#'))
                    //     this.defaultSettings(text.split('##defaultSettings#')[1])
                    // } else if(text.startsWith('##')) {
                    //     this.dealDirectiveMsg(fromUserId, text);
                    // } else {
                    //     this.showMessageInBox(fromUserId, text);
                    // }
                },

                /**
                 * 收到C2C自定义消息
                 * @param fromUserId		发送此消息的用户id
                 * @param data				收到消息的内容
                 * @param dataLen			收到消息的长度
                 */
                onTICRecvCustomMessage: (fromUserId, data, textLen) => {
                    console.log(fromUserId, text, textLen)
                    // if(text.startsWith('##stuLoadPythonCode')) {
                    //     this.currentPythonCode = text.slice(20);
                    //     // this.promptShow = true;
                    //     this.onSaveWork();
                    // } else if(text.startsWith('##defaultSettings')) {
                    //     this.defaultSettings(text.split('##defaultSettings#')[1])
                    // } else if(text.startsWith('##')) {
                    //     this.dealDirectiveMsg(fromUserId, text);
                    // } else {
                    //     this.showMessageInBox(fromUserId, text);
                    // }
                },

                /**
                 * 收到群文本消息
                 * @param fromUserId		发送此消息的用户id
                 * @param text				收到消息的内容
                 * @param textLen			收到消息的长度
                 */
                onTICRecvGroupTextMessage: (fromUserId, text, textLen) => {
                    console.log(fromUserId, text, textLen)
                    // if(text.startsWith('##stuLoadPythonCode')) {
                    //     this.currentPythonCode = text.slice(20);
                    //     // this.promptShow = true;
                    //     this.onSaveWork();
                    // } else if(text.startsWith('##')) {
                    //     this.dealDirectiveMsg(fromUserId, text);
                    // } else {
                    //     this.showMessageInBox(fromUserId, text);
                    //     if(this.fun_tab_active != '消息') {
                    //         this.$set(this.fun_tab[0], 'hidden', false);
                    //         console.log(this.fun_tab[0])
                    //     }
                    // }
                },

                /**
                 * 收到群自定义消息
                 * @param fromUserId		发送此消息的用户id
                 * @param data				收到消息的内容
                 * @param dataLen			收到消息的长度
                 */
                onTICRecvGroupCustomMessage: (fromUserId, data, textLen) => {
                    console.log(fromUserId, text, textLen)
                    // if(text.startsWith('##')) {
                    //     this.dealDirectiveMsg(fromUserId, text);
                    // } else {
                    //     this.showMessageInBox(fromUserId, text);
                    // }
                },

                /**
                 * 所有消息
                 * @param msg	IM消息体
                 * @note 所有收到的消息都会在此回调进行通知，包括前面已经封装的文本和自定义消息（白板信令消息除外）
                 */
                onTICRecvMessage(msg) {

                }
            });
        },
        // 事件监听回调
        addTICEventListener() {
            this.tic.addTICEventListener({
                onTICMemberJoin: (members) => {
                    // this.showMessageInBox('群消息', members.join(',') + '进入课堂');
                },

                onTICMemberQuit: (members) => {
                    // this.showMessageInBox('群消息', members.join(',') + '退出课堂');
                },

                onTICClassroomDestroy: () => {
                    console.log("教师解散了课堂")
                    // this.quitClassroom();
                    // this.showTip(`教师解散了课堂`);
                },

                onTICTrtcClientCreated: () => {
                    console.log("111111111111111111111111111111111111")
                    window.trtcClient = this.trtcClient = this.tic.getTrtcClient();
                    // this.initTRTCEvent();
                },
                onTICUserSubStreamAvailable: (userId, available) => {
                    console.log(userId, available)
                },
                onTICUserVideoAvailable: (userId, available) => {
                    console.log(userId, available)
                }
            });
        },
        // 创建房间
        createClassroom() {
            this.tic.createClassroom({
                classId: this.classId,
                classScene: TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_VIDEO_CALL // 1：直播模式 0: 实时模式
            }, (res) => {
                if (res.code) {
                    console.log(res)
                    if (res.code == 10021) {
                        this.joinClassroom();
                        // this.showTip('该课堂已被他人创建，请直接加入');
                    } else if (res.code == 10025) {
                        this.joinClassroom();
                        // this.showTip('您已经创建过这个课堂，请直接加入');
                    } else {
                        // this.showErrorTip('创建课堂失败');
                        console.error(res);
                    }
                } else {
                    this.joinClassroom();
                    // this.showTip('创建课堂成功');
                }
            });
        },
        // 进入房间
        joinClassroom() {
            if (this.status == this.STATUS_INCLASS) {
                return;
            }

            this.tic.joinClassroom({
                // compatSaas: true,
                classId: this.classId,
            }, {
                // mode: TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_LIVE //直播模式，支持1000人以上场景
                mode: TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_VIDEO_CALL, // //实时通话模式，支持1000人以下场景，低延时
                // role: TIC.CONSTANT.TICRoleType.TIC_ROLE_TYPE_ANCHOR // 主播，只在TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_LIVE模式下有效
                // role: TIC.CONSTANT.TICRoleType.TIC_ROLE_TYPE_AUDIENCE // 观众（观众角色没有发布本地流的权限，只有收看远端流的权限。如果观众想要连麦跟主播互动， 请先通过 switchRole() 切换角色到主播 anchor 后再发布本地流），只在TIC.CONSTANT.TICClassScene.TIC_CLASS_SCENE_LIVE模式下有效
            }, {
                id: 'paint_box',
                ratio: '16:9',
                smoothLevel: 0,
                boardContentFitMode: 1,
                toolType: 1
            }, res => {
                if (res.code) {
                    // this.showErrorTip('加入课堂失败');

                    console.error(res);
                } else {
                    this.status = this.STATUS_INCLASS;
                    // this.showTip('加入课堂成功');
                    this.startRTC();
                    window.teduBoard = this.teduBoard = this.tic.getBoardInstance();
                    this.initBoardEvent();
                }
            });
        },
        // 监听白板事件（按需监听）
        initBoardEvent() {
            var teduBoard = this.teduBoard;
            // 撤销状态改变
            teduBoard.on(TEduBoard.EVENT.TEB_OPERATE_CANUNDO_STATUS_CHANGED, (enable) => {
                this.canUndo = enable ? 1 : 0;
                console.log('======================:  ', 'TEB_OPERATE_CANUNDO_STATUS_CHANGED', enable ? '可撤销' : '不可撤销');
            });

            // 重做状态改变
            teduBoard.on(TEduBoard.EVENT.TEB_OPERATE_CANREDO_STATUS_CHANGED, (enable) => {
                this.canRedo = enable ? 1 : 0;
                console.log('======================:  ', 'TEB_OPERATE_CANREDO_STATUS_CHANGED', enable ? '可恢复' : '不可恢复');
            });

            // 新增白板
            teduBoard.on(TEduBoard.EVENT.TEB_ADDBOARD, (boardIds, fid) => {
                console.log('======================:  ', 'TEB_ADDBOARD', ' boardIds:', boardIds, ' fid:', fid);
                this.proBoardData();
            });

            // 白板同步数据回调(收到该回调时需要将回调数据通过信令通道发送给房间内其他人，接受者收到后调用AddSyncData接口将数据添加到白板以实现数据同步)
            // TIC已经处理好了，可忽略该事件
            teduBoard.on(TEduBoard.EVENT.TEB_SYNCDATA, (data) => {
                this.teduBoard.setDrawEnable(false);
                this.teduBoard.showVideoControl(false);
                this.teduBoard.setSyncVideoStatusEnable(false);
                console.log('======================:  ', 'TEB_SYNCDATA');
            });

            // 收到白板初始化完成事件后，表示白板已处于正常工作状态（此时白板为空白白板，历史数据尚未拉取完成）
            teduBoard.on(TEduBoard.EVENT.TEB_INIT, () => {
                console.log('======================:  ', 'TEB_INIT');
            });

            teduBoard.on(TEduBoard.EVENT.TEB_HISTROYDATA_SYNCCOMPLETED, () => {
                console.log('======================:  ', 'TEB_HISTROYDATA_SYNCCOMPLETED');

                // setTimeout(() => {
                //   teduBoard.addImage('https://main.qcloudimg.com/raw/5c11f1a14f74b00988c5c43dddff2d41.png');
                //   // teduBoard.addImage('https://main.qcloudimg.com/raw/ea3692fd322dbcc7d86c3fc3cc6d3c59.jpg');
                // }, 2000);
            });

            // 白板错误回调
            teduBoard.on(TEduBoard.EVENT.TEB_ERROR, (code, msg) => {
                console.error('======================:  ', 'TEB_ERROR', ' code:', code, ' msg:', msg);
            });

            // 白板警告回调
            teduBoard.on(TEduBoard.EVENT.TEB_WARNING, (code, msg) => {
                console.error('======================:  ', 'TEB_WARNING', ' code:', code, ' msg:', msg);
            });

            // 图片状态加载回调
            teduBoard.on(TEduBoard.EVENT.TEB_IMAGE_STATUS_CHANGED, (status, data) => {
                console.log('======================:  ', 'TEB_IMAGE_STATUS_CHANGED', ' status:', status, ' data:', data);
            });

            // 删除白板页回调
            teduBoard.on(TEduBoard.EVENT.TEB_DELETEBOARD, (boardIds, fid) => {
                console.log('======================:  ', 'TEB_DELETEBOARD', ' boardIds:', boardIds, ' fid:', fid);
                this.proBoardData();
            });

            // 跳转白板页回调
            teduBoard.on(TEduBoard.EVENT.TEB_GOTOBOARD, (boardId, fid) => {
                console.log('======================:  ', 'TEB_GOTOBOARD', ' boardId:', boardId, ' fid:', fid);
                this.proBoardData();
            });

            // ppt动画步数改变回调
            teduBoard.on(TEduBoard.EVENT.TEB_GOTOSTEP, (step, count) => {
                console.log('======================:  ', 'TEB_GOTOSTEP', ' step:', step, ' count:', count);
            });

            // 增加H5动画PPT文件回调
            teduBoard.on(TEduBoard.EVENT.TEB_ADDH5PPTFILE, (fid) => {
                console.log('======================:  ', 'TEB_ADDH5PPTFILE', ' fid:', fid);
                this.proBoardData();
            });

            // 增加文件回调
            teduBoard.on(TEduBoard.EVENT.TEB_ADDFILE, (fid) => {
                console.log('======================:  ', 'TEB_ADDFILE', ' fid:', fid);
                this.proBoardData();
            });

            // 增加转码文件回调
            teduBoard.on(TEduBoard.EVENT.TEB_ADDTRANSCODEFILE, (fid) => {
                console.log('======================:  ', 'TEB_ADDTRANSCODEFILE', ' fid:', fid);
                this.proBoardData();
            });

            // 删除文件回调
            teduBoard.on(TEduBoard.EVENT.TEB_DELETEFILE, (fid) => {
                console.log('======================:  ', 'TEB_DELETEFILE', ' fid:', fid);
                this.proBoardData();
            });

            // 文件上传状态
            teduBoard.on(TEduBoard.EVENT.TEB_FILEUPLOADSTATUS, (status, data) => {
                console.log('======================:  ', 'TEB_FILEUPLOADSTATUS', status, data);
                if (status === 1) {
                    // this.showTip('上传成功');
                } else {
                    // this.showTip('上传失败');
                }
                document.getElementById('file_input').value = '';
            });

            // 切换文件回调
            teduBoard.on(TEduBoard.EVENT.TEB_SWITCHFILE, (fid) => {
                console.log('======================:  ', 'TEB_SWITCHFILE', ' fid:', fid);
                if (fid === '#1573462129974') {
                    teduBoard.gotoBoard('web_tic_10_1573462130_8_#1573462129974')
                } else if (fid === '#1573218991727') {
                    teduBoard.gotoBoard('miniprogram_miniprogram_tic_201_1573218991_3_#1573218991727')
                }
                this.proBoardData();
            });

            // 上传背景图片的回调
            teduBoard.on(TEduBoard.EVENT.TEB_SETBACKGROUNDIMAGE, (fileName, fileUrl, userData) => {
                console.log('======================:  ', 'TEB_SETBACKGROUNDIMAGE', '  fileName:', fileName, '  fileUrl:', fileUrl, ' userData:', userData);
            });

            // 文件上传进度
            teduBoard.on(TEduBoard.EVENT.TEB_FILEUPLOADPROGRESS, (data) => {
                console.log('======================:  ', 'TEB_FILEUPLOADPROGRESS:: ', data);
                // this.showTip('上传进度:' + parseInt(data.percent * 100) + '%');
            });

            // H5背景加载状态
            teduBoard.on(TEduBoard.EVENT.TEB_H5BACKGROUND_STATUS_CHANGED, (status, data) => {
                console.log('======================:  ', 'TEB_H5BACKGROUND_STATUS_CHANGED:: status:', status, '  data:', data);
            });

            // 转码进度
            teduBoard.on(TEduBoard.EVENT.TEB_TRANSCODEPROGRESS, res => {
                console.log('=======  TEB_TRANSCODEPROGRESS 转码进度：', JSON.stringify(res));
                if (res.code) {
                    // this.showErrorTip('转码失败code:' + res.code + ' message:' + res.message);
                } else {
                    let status = res.status;
                    if (status === 'ERROR') {
                        // this.showErrorTip('转码失败');
                    } else if (status === 'UPLOADING') {
                        // this.showTip('上传中，当前进度:' + parseInt(res.progress) + '%');
                    } else if (status === 'CREATED') {
                        // this.showTip('创建转码任务');
                    } else if (status === 'QUEUED') {
                        // this.showTip('正在排队等待转码');
                    } else if (status === 'PROCESSING') {
                        // this.showTip('转码中，当前进度:' + res.progress + '%');
                    } else if (status === 'FINISHED') {
                        // this.showTip('转码完成');
                        this.teduBoard.addTranscodeFile({
                            url: res.resultUrl,
                            title: res.title,
                            pages: res.pages,
                            resolution: res.resolution
                        });
                    }
                }
            });
        },
        /**
         * 白板事件回调处理 
         * @param {*} data 
         */
        proBoardData(data) {
            this.fileInfoList = this.teduBoard.getFileInfoList();
            this.currentFileId = this.teduBoard.getCurrentFile();
            var fileInfo = this.teduBoard.getFileInfo(this.currentFileId);
            if (fileInfo) {
                this.boardData = {
                    currentBoardId: this.currentFileId,
                    boardIdlist: this.teduBoard.getFileBoardList(this.currentFileId),
                    current: fileInfo.currentPageIndex + 1,
                    total: fileInfo.pageCount
                }
            }
        },
        addTICStatusListener() {
            this.tic.addTICStatusListener({
                onTICForceOffline: async() => {
                    // // eslint-disable-next-line no-alert
                    // // alert(`其他地方登录，被T了`);
                    // clearInterval(this.dotInterval);
                    // await this.logout();
                    // this.$router.replace('/personhome')
                    console.log("老师结课")
                    this.status = this.STATUS_UNLOGIN;
                }
            });
        },
        // 启动推流(推摄像头)
        startRTC() {
            // 从麦克风和摄像头采集本地音视频流
            this.cameraStream = TRTC.createStream({
                audio: true,
                video: true
            });
            // 设置视频分辨率等参数
            this.cameraStream.setVideoProfile('480p');
            if (this.localStream && this.isPushing) { // 如果正在推流, 先停止发布流
                this.stopPush(() => {
                    this.publishLocalStream(this.cameraStream);
                });
            } else {
                this.publishLocalStream(this.cameraStream);
            }
        },
        //结束推流
        stopPush(callback) {
            if (this.localStream && this.isPushing) {
                this.trtcClient.unpublish(this.localStream).then(() => {
                    this.isPushing = 0;
                    document.getElementById('local_video').remove();
                    this.localStream.stop();
                    this.localStream = null;
                    if (Object.prototype.toString.call(callback) === '[object Function]') {
                        callback();
                    }
                });
            }
        },
        //播放远端流
        currentVideoPlay(item, index, type) {
            this.$nextTick(() => {
                if(!item.play) {
                    if(type) {
                        this.$set(this.screenStreamList[index], 'play', true);
                        item.stream.play(document.getElementById(item.stream.getId()));
                    } else {
                        if(item.roles == '教师') {
                            this.$set(this.teacherRemoteStreamList[index], 'play', true);
                            item.stream.play(document.getElementById(item.stream.getId()));
                        } else {
                            this.$set(this.stuRemoteStreamList[index], 'play', true);
                            item.stream.play(document.getElementById(item.stream.getId()));
                        }
                    }
                }
            })
        },
        //发布流
        publishLocalStream(localStream, type) {
            window.localStream = localStream;
            localStream.initialize().catch(error => {
                console.error('failed initialize localStream ' + error);
            }).then(() => {
                if(type == 'screen') {
                    var localVideoWrapEl = document.getElementById('screen');
                    if (!localVideoWrapEl) {
                        localVideoWrapEl = document.createElement('div');
                        localVideoWrapEl.id = 'screen';
                        localVideoWrapEl.style.width = '100%';
                        localVideoWrapEl.style.height = '100%';
                        document.querySelector("#video_wrap").insertBefore(localVideoWrapEl, null);
                        // document.querySelector("#video_teacher_list").insertBefore(localVideoWrapEl, null);
                    }
                    // 本地流播放
                    localStream.play(localVideoWrapEl, {
                        muted: true
                    });
                } else {
                    this.stuRemoteStreamList.push({
                        stream: localStream,
                        id: 'i',
                        play: false,
                        video: true,
                        audio: true,
                        roles: "学生"
                    })
                }
                this.toggleMic();

                // 发布本地流（远端可收到）
                this.trtcClient && this.trtcClient.publish(localStream).then(() => {
                    // 本地流发布成功
                    this.isPushing = 1; // 正在推流
                    this.isPushCamera = true; // 正在推摄像头
                    this.localStream = localStream;
                    // this.showTip('推流成功');
                }).catch(error => {
                    console.log(error);
                });
            }).catch(error => {
                // this.showErrorTip(`获取本地流失败, ${JSON.stringify(error)}`);
            });
        },
        /**
        * 麦克风开关
        */
        toggleMic() {
            this.enableMic = !this.enableMic
            if (this.localStream) {
                this.localStream.muteAudio()
            }
        },
    },
}
</script>
<style lang="scss">
.boardPage {
    width: 100%;
    height: 100%;
    #paint_box {
        width: 100%;
        height: 100%;
    }
    .teacher_video,
    .student_video {
        position: relative;
        width: 100%;
        height: 180px;
        box-sizing: border-box;
        border: 2px solid var(--theme-color);
        overflow: hidden;
    }
    .my_video {
        // position: absolute;
        // right: 0;
        // top: 110px;
        width: 200px;
        height: 140px;
    }
    .my_video .student_control {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 30px;
        background: rgba(0, 0, 0, .5);
        z-index: 5;
    }
    .my_video .student_control img {
        width: 20px;
        margin: 5px;
        cursor: pointer;
    }
    .platform {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
    }
    .platform .my_video {
        position: relative;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 180px;
    }
    .teacher_name,
    .student_name {
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        font-size: 13px;
        padding: 2px;
        background-color: rgba(0, 0, 0, .5);
        z-index: 5;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/board/board.vue